export const  FACEBOOK_ID = '542650433432161'
export const  GOOGLE_ID = '709638401397-fon8prsvg1m4tjvpldhkt1qukvohvl8a.apps.googleusercontent.com'
export const  GO_SELL_PUBLIC_KEY = process.env.VUE_APP_TAP_PUBLIC_KEY;
export const STRIPE_PUBLIC_KEY = process.env.VUE_APP_STRIPE_PUBLIC_KEY;